import { getSessionHint } from "./sessionHint";

export function readSessionClaims() {
  try {
    const hint = getSessionHint();
    return hint ? { role: hint.role, user: hint.user } : {};
  } catch (_error) {
    return {};
  }
}

export function readSessionRole() {
  const claims = readSessionClaims();
  const role = String(claims.role || claims.role_slug || claims.roleSlug || claims.user?.role || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  return role === "super_admin" ? "superadmin" : role;
}
